import { Button, Flex, Modal, Typography } from 'antd';

import type { MassActionTypeModalType } from '@app/components/Modals/MassActionTypeModal/types';

const { Text } = Typography;
export const MassActionTypeModal: MassActionTypeModalType = ({
  type = 'clients',
  isOpen,
  onClose,
  onConfirm,
  disabledSelectedItemsActions,
  selectedCount,
  allCount,
}) => {
  const text = type === 'clients' ? 'клиентов' : 'лидов';
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      title="Применить действие"
      footer={
        <Flex flex="1" gap={16}>
          <Button
            disabled={disabledSelectedItemsActions}
            type="primary"
            className="full-width"
            onClick={() => {
              onConfirm('selected');
              onClose();
            }}
          >
            Только для выбранных
          </Button>
          <Button
            className="full-width"
            onClick={() => {
              onConfirm('all');
              onClose();
            }}
          >
            Для активного фильтра
          </Button>
        </Flex>
      }
    >
      <Text>
        Применить действие для всех {text} попадающих в фильтр или только на
        выбранных? Выбранных {selectedCount}, всего {allCount}.
      </Text>
    </Modal>
  );
};
